// TransformerContext.js
import { createContext, useState } from "react";

export const TransformerContext = createContext();

export function TransformerProvider({ children }) {
  const [transformerData, setTransformerData] = useState({
    "TR-201": {
      running: false,
      voltage: 22
    }
  });

  const updateTransformer = (tag, updates) => {
    setTransformerData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        ...updates
      }
    }));
  };

  return (
    <TransformerContext.Provider value={{ transformerData, updateTransformer }}>
      {children}
    </TransformerContext.Provider>
  );
}